import { apiSlice } from '../apiSlice';
import { AgeSource } from '../enum/common.enum';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	PreAdmissionDetailDTO,
	PreAdmissionFilter,
	PreAdmissionPageDTO,
} from '../DTO/pre-admission/preAdmission.interface';

export const preAdmission = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getPreAdmissionList: builder.query<
			SuccessResponse<Paginated<PreAdmissionPageDTO>>,
			PreAdmissionFilter
		>({
			query: (body) => ({
				url: `/web/pre-admission/page`,
				method: 'POST',
				body,
			}),
		}),
		getPreAdmissionDetail: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/pre-admission/${id}`,
				method: 'GET',
			}),
			providesTags: ['PreAdmissionDetail'],
		}),
		createPreAdmission: builder.mutation<
			SuccessResponse<any>,
			PreAdmissionDetailDTO
		>({
			query: (body) => ({
				url: `/web/pre-admission`,
				method: 'POST',
				body,
			}),
		}),
		editPreAdmission: builder.mutation<
			SuccessResponse<any>,
			PreAdmissionDetailDTO
		>({
			query: (body) => ({
				url: `/web/pre-admission/${body.id}/${body.type}`,
				method: 'PUT',
				body,
			}),
		}),
		updatePreAdmissionStatus: builder.mutation<
			SuccessResponse<any>,
			{
				id: string;
				preAdmissionStatus: number | string;
				caseSupervisorId: string;
				/** Link in the same transaction; only used when Submitted. */
				closedUserId?: string;
				legacyFileNo?: string;
				/** Age of the new admission request; only used when Submitted. */
				ageSource?: AgeSource;
				dateOfBirth?: string | null;
				estimatedAge?: number | null;
			}
		>({
			query: (body) => ({
				url: `/web/pre-admission/${body.id}/status`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['PreAdmissionDetail'],
		}),
		deletePreAdmission: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/pre-admission/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useGetPreAdmissionListQuery,
	useGetPreAdmissionDetailQuery,
	useCreatePreAdmissionMutation,
	useEditPreAdmissionMutation,
	useUpdatePreAdmissionStatusMutation,
	useDeletePreAdmissionMutation,
} = preAdmission;
